module.exports = __webpack_public_path__ + "img/rotation.e256a1e0.svg";